import {
    USER_SUBMIT_FRUI_QPXH_BEGIN,
    USER_SUBMIT_FRUI_QPXH_SUCCESS,
    USER_SUBMIT_FRUI_QPXH_FAILURE,
    USER_SUBMIT_FRUI_QPXH_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitFrui_qpxh(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: USER_SUBMIT_FRUI_QPXH_BEGIN,
      });
  
      let apiurl = '/api/b/frui_qpxh/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/frui_qpxh/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: USER_SUBMIT_FRUI_QPXH_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: USER_SUBMIT_FRUI_QPXH_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitFrui_qpxhError() {
    return {
      type: USER_SUBMIT_FRUI_QPXH_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case USER_SUBMIT_FRUI_QPXH_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitFrui_qpxhPending: true,
          submitFrui_qpxhError: null,
        };
  
      case USER_SUBMIT_FRUI_QPXH_SUCCESS:
        // The request is success
        return {
          ...state,
          submitFrui_qpxhPending: false,
          submitFrui_qpxhError: null,
        };
  
      case USER_SUBMIT_FRUI_QPXH_FAILURE:
        // The request is failed
        return {
          ...state,
          submitFrui_qpxhPending: false,
          submitFrui_qpxhError: action.data.error,
        };
  
      case USER_SUBMIT_FRUI_QPXH_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitFrui_qpxhError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/user/redux/submitFrui_qpxh.js